import { ComponentType } from '../ui/shared/LinkTypes'; // Importing ComponentType enum
import { Context } from '../ui/shared/enums/Context';
import { FontWeight } from '../ui/shared/enums/FontWeight';
import { UnderLineType } from '../ui/shared/enums/UnderLineType';
/**
 * Default configurations for link types
 */
export const defaultBaseLink = {
    link: '',
    text: '',
};
export const defaultInteractiveEmailElement = {
    ...defaultBaseLink,
    email: '',
    subject: 'Query From Website',
    componentType: ComponentType.Email, // Ensuring type safety with ComponentType enum
};
export const defaultInteractivePhoneElement = {
    ...defaultBaseLink,
    phone: '',
    componentType: ComponentType.Telephone, // Ensuring type safety with ComponentType enum
};
export const defaultLink = {
    id: 0,
    ...defaultBaseLink,
    // TODO - this needs to be fixed in order to hace the hover color working
    hoverColor: '',
    isUnderLine: UnderLineType.Underline, // Using UnderLineType enum
    linkColor: Context.None, // Using Context enum
    componentType: ComponentType.Internal, // Using ComponentType enum
};
/**
 * Placeholder configurations for link types, for use in testing or development
 */
export const placeholderBaseLink = {
    link: 'https://domain/some-link',
    text: 'Some Descriptive Text For The Link',
};
export const placeholderInteractiveEmailElement = {
    ...placeholderBaseLink,
    email: 'email@example.com',
    subject: 'Query From Website',
    componentType: ComponentType.Email, // Ensuring type safety with ComponentType enum
};
export const placeholderInteractivePhoneElement = {
    ...placeholderBaseLink,
    phone: '123456789',
    componentType: ComponentType.Telephone, // Ensuring type safety with ComponentType enum
};
export const placeholderLink = {
    id: 1,
    ...placeholderBaseLink,
    fontWeight: FontWeight.Normal, // Using FontWeight enum
    hoverColor: '',
    isUnderLine: UnderLineType.Underline, // Using UnderLineType enum
    linkColor: Context.None, // Using Context enum
    componentType: ComponentType.Internal, // Using ComponentType enum
};
//# sourceMappingURL=LinkDefaults.js.map